module.exports = __webpack_public_path__ + "static/media/paper_top.b6655564.png";